import styled from "styled-components";

export const TabsWrapper = styled.div`
  display: flex;
  background-color: #f1f2f6; // tom claro do fundo fora da aba selecionada
  padding: 4px;
  border-radius: 8px;
  gap: 8px;
  width: max-content;
`;

export const TabButton = styled.button<{ isActive: boolean; index: number }>`
  background-color: ${({ isActive }) => (isActive ? "#ffffff" : "transparent")};
  color: #333;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ isActive }) => (isActive ? "#ffffff" : "#e1e2e6")};
  }
`;
